import {useSuspenseQuery} from "@apollo/client";
import {ProductModel} from "../models/domain/productModel";
import {useProductVariables} from "./useProductVariables";
import {contentService} from "../api/contentService";

export const useProductDetailsQuery = () => {
    const {variables} = useProductVariables();
    const {data, error} = useSuspenseQuery(contentService.product.details, {variables});
    return {model: new ProductModel(data?.product), error};
}